import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

export interface AuctionState {
  newAuctionName: string;
  newAuctionWallet: string;
  newAuctionPrice: number;
  newAuctionBetStep: number;
  newAuctionEndDate: number;
  bidAmount: number;
  bidWallet: string;
  payWallet: string;
  winnerPrice: number;
  payAuctionId: string;
  downloadProgress: number;
  purchasePrice: string;
}

const initialState: AuctionState = {
  newAuctionName: '',
  newAuctionPrice: 0.01,
  newAuctionBetStep: 0.01,
  bidAmount: 0.01,
  newAuctionEndDate: 0,
  newAuctionWallet: '',
  bidWallet: '',
  payWallet: '',
  winnerPrice: 0,
  payAuctionId: '',
  downloadProgress: 0,
  purchasePrice: '',
};

export const AuctionSlice = createSlice({
  name: 'fs',
  initialState,
  reducers: {
    setAuctioName: (state, {payload}: PayloadAction<string>) => {
      state.newAuctionName = payload;
    },
    setAuctionPrice: (state, {payload}: PayloadAction<number>) => {
      state.newAuctionPrice = payload;
    },
    setBidAmount: (state, {payload}: PayloadAction<number>) => {
      state.bidAmount = payload;
    },
    setBidWallet: (state, {payload}: PayloadAction<string>) => {
      state.bidWallet = payload;
    },
    setAuctioEndDate: (state, {payload}: PayloadAction<number>) => {
      state.newAuctionEndDate = payload;
    },
    setAuctionWallet: (state, {payload}: PayloadAction<string>) => {
      state.newAuctionWallet = payload;
    },
    setPayWallet: (state, {payload}: PayloadAction<string>) => {
      state.payWallet = payload;
    },
    setWinnerPrice: (state, {payload}: PayloadAction<number>) => {
      state.winnerPrice = payload;
    },
    setAuctionBetStep: (state, {payload}: PayloadAction<number>) => {
      state.newAuctionBetStep = payload;
    },
    setPurchasePrice: (state, {payload}: PayloadAction<string>) => {
      state.purchasePrice = payload;
    },
    setDownloadProgress: (
      state,
      {payload}: PayloadAction<number>,
    ) => {
      state.downloadProgress = payload;
    },
  },
});

export const {
  setAuctioName,
  setAuctioEndDate,
  setAuctionPrice,
  setAuctionWallet,
  setAuctionBetStep,
  setBidAmount,
  setBidWallet,
  setPayWallet,
  setWinnerPrice,
  setDownloadProgress,
  setPurchasePrice,
} = AuctionSlice.actions;

export default AuctionSlice.reducer;
